import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import styles from './index.module.scss';

interface LauncherProps {
  type?: string;
  error?: any;
  pastDelay?: boolean;
}

const Launcher: React.FC<LauncherProps> = ({ type, error, pastDelay }) => {
  if (type === 'loading') {
    if (error) {
      return (
        <div className="error">
          <h2>ERROR</h2>
          <p>{error.message}</p>
        </div>
      );
    }
    if (pastDelay) {
      return <div className="loading" />;
    }
    return null;
  }
  if (type === '404') {
    return (
      <div className={`${styles.launcher} ${styles.notFound}`}>
        <h2>404</h2>
        <p>页面去哪了？</p>
      </div>
    );
  }
  if (type === '403') {
    return (
      <div className={`${styles.launcher} ${styles.noPrivilege}`}>
        <h2>无权限</h2>
        <Link to="/welcome">
          <Button>回到欢迎页</Button>
        </Link>
      </div>
    );
  }
  return null;
};

export default Launcher;
